import React, { useEffect, useState } from 'react';
import { Modal, Form, Select, Radio, Button, Row, Col, Space } from 'antd';
import { fetchBranches } from '../api';
import RoleSelect from '../../../components/UI/RoleSelect';

const { Option } = Select;

const SORT_FIELDS = [
  { label: "Created At", value: "createdAt" },
  { label: "Name", value: "name" },
  { label: "Email", value: "email" },
  { label: "Roll", value: "roll" },
  { label: "Branch", value: "branchName" },
];

const SORT_ORDERS = [
  { label: "Ascending", value: "asc" },
  { label: "Descending", value: "desc" },
];

const UserFilterPopup = ({ visible, onClose, onApplyFilters, initialFilters }) => {
  const [form] = Form.useForm();
  const [branches, setBranches] = useState([]);

  useEffect(() => {
    if (visible) {
      loadBranches();
      // Set initial values when popup opens
      form.setFieldsValue({
        role: initialFilters.role || '',
        status: initialFilters.status || '',
        branch: initialFilters.branch || '',
        sortField: initialFilters.sortField || 'createdAt',
        sortOrder: initialFilters.sortOrder || 'desc',
      });
    }
  }, [visible, initialFilters, form]);

  const loadBranches = async () => {
    try {
      const response = await fetchBranches({});
      if (response.success) {
        setBranches(response.data);
      }
    } catch (error) {
      console.error('Error loading branches:', error);
    }
  };

  const handleApply = () => {
    form.validateFields()
      .then(values => {
        onApplyFilters(values);
      })
      .catch(() => {
        // ignore validation errors here
      });
  };

  return (
    <Modal
      title="Filter & Sort Users"
      visible={visible}
      onCancel={onClose}
      footer={
        <Row justify="space-between" style={{ width: '100%' }}>
          <Col>
            <Button onClick={() => form.resetFields()}>Reset</Button>
          </Col>
          <Col>
            <Space>
              <Button onClick={onClose}>Cancel</Button>
              <Button type="primary" onClick={handleApply}>
                Apply
              </Button>
            </Space>
          </Col>
        </Row>
      }
      centered
      destroyOnClose={false} // Keep state between opens
      width={450}
      bodyStyle={{ paddingTop: 12 }}
      maskClosable={false}
      style={{ maxWidth: '95vw' }}
    >
      <Form layout="vertical" form={form}>
        <Form.Item label="Role" name="role">
          <RoleSelect placeholder="Select Role" allowClear />
        </Form.Item>

        <Form.Item label="Branch" name="branch">
          <Select placeholder="Select Branch" allowClear>
            {branches.map((branch) => (
              <Option key={branch._id} value={branch._id}>
                {branch.name} ({branch.code})
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item label="Status" name="status">
          <Select placeholder="Select Status" allowClear>
            <Option value="active">Active</Option>
            <Option value="inactive">Inactive</Option>
          </Select>
        </Form.Item>

        <Form.Item label="Sort By" name="sortField">
          <Select>
            {SORT_FIELDS.map((field) => (
              <Option key={field.value} value={field.value}>
                {field.label}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item label="Sort Order" name="sortOrder">
          <Radio.Group>
            {SORT_ORDERS.map((order) => (
              <Radio key={order.value} value={order.value}>
                {order.label}
              </Radio>
            ))}
          </Radio.Group>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default UserFilterPopup;
